import Cookies from 'js-cookie'

const UIDKey = 'adminUID'
const UsernameKey = 'adminUsername'

export function getUID () {
  return Cookies.get(UIDKey)
}

export function setUID (uid) {
  return Cookies.set(UIDKey, uid)
}

export function removeUID () {
  return Cookies.remove(UIDKey)
}

export function getUsername () {
  return Cookies.get(UsernameKey)
}

export function setUsername (username) {
  return Cookies.set(UsernameKey, username)
}

export function removeUsername () {
  return Cookies.remove(UsernameKey)
}

export function setLogin (data, resolve, commit) {
  var r = { path: '/' }
  if (data.mfa_enabled) {
    r.path = '/otp'
  } else {
    Cookies.set(UIDKey, data.uid)
    Cookies.set(UsernameKey, data.username)
    commit('SET_UID', data.uid)
    commit('SET_UNAME', data.username)
  }
  resolve(r)
}
